module.exports = __webpack_public_path__ + "static/img/tx_zq.551a859.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/team/tx_zq.png
// module id = j8IM
// module chunks = 0